module.exports = __webpack_public_path__ + "static/media/logo_approved_companies.ccced69d.png";